import { useTitle } from "../ui/hooks";
import { Hero, Marquee } from "./home/Hero";
import { Pillars } from "./home/Pillars";
import { CharterTeaser, ProductsTeaser, SeriesTeaser } from "./home/Teasers";
import { WorkflowFeature } from "./home/WorkflowFeature";

export function Home() {
  useTitle("AI, held to account");
  return (
    <>
      <Hero />
      <Marquee />
      <Pillars />
      <WorkflowFeature />
      <ProductsTeaser />
      <CharterTeaser />
      <SeriesTeaser />
    </>
  );
}
